export const EDIT_HEADER = 'Edit Class'
export const COURSE_INSTANCE_LABEL = 'Class Name'
export const COURSE_INSTANCE_PLACEHOLDER = 'Enter a class name'
export const EDIT_SUBMIT = 'Save Changes'
export const EDIT_CANCEL = 'Cancel'

// Small Group specific labels
export const EDIT_HEADER_SMALL_GROUP = 'Edit Small Group'
export const SMALL_GROUP_LABEL = 'Small Group Name'
export const SMALL_GROUP_PLACEHOLDER = 'Enter a small group name'
